import { COLOR, FONT_SIZE, FONT_WEIGHT, mq } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const SpanOriginalPrice = styled.span<{ isStrikethrough?: boolean }>`
  font-size: ${FONT_SIZE.S}px;
  line-height: 1;
  text-decoration: ${({ isStrikethrough }) => (isStrikethrough ? "line-through" : "none")};
  color: ${({ isStrikethrough }) => (isStrikethrough ? `${COLOR.GRAY500.code}` : `${COLOR.GRAY900.code}`)};

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const SpanSalePrice = styled.span`
  font-size: ${FONT_SIZE.S}px;
  line-height: 1;
  margin-left: 4px;

  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const SpanPriceLabel = styled.span`
  font-size: ${FONT_SIZE.S}px;
  margin-right: 4px;
  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;

export const SpanSalePriceLabel = styled.span`
  font-size: ${FONT_SIZE.S}px;
  font-weight: ${FONT_WEIGHT.BOLD};
  color: ${COLOR.YELLOW50.code};
  ${mq.sp} {
    font-size: ${FONT_SIZE.XS}px;
  }
`;
